import {
  IMPLEMENTATION as IMPLEMENTATION_ENUM,
  ACTIVE as ACTIVE_ENUM,
  INACTIVE as INACTIVE_ENUM,
  TERMINATED as TERMINATED_ENUM,
} from "./clientStatusTypes";

export const IMPLEMENTATION = {
  IMPLEMENTATION: [IMPLEMENTATION_ENUM, ACTIVE_ENUM],
};
export const ACTIVE = {
  ACTIVE: [ACTIVE_ENUM, INACTIVE_ENUM],
};
export const INACTIVE = {
  INACTIVE: [INACTIVE_ENUM, ACTIVE_ENUM],
};
export const TERMINATED = {
  TERMINATED: [TERMINATED_ENUM],
};

export default [IMPLEMENTATION, ACTIVE, INACTIVE, TERMINATED];



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/enums/validClientStatusTransitions.js